import { Action, createReducer, on } from '@ngrx/store';
import {
  LicenseException,
  LicensePaymentDataMonthResponse,
  LicensePaymentDataYearResponse,
  LicenseResponse,
} from '../../../api/models';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { accountActions } from './account.actions';

export interface AccountState {
  license: {
    state: ILoaderActionPayload;
    data?: LicenseResponse;
  };
  monthPaymentLicense: {
    state: ILoaderActionPayload;
    data?: LicensePaymentDataMonthResponse;
  };
  yearPaymentLicense: {
    state: ILoaderActionPayload;
    data?: LicensePaymentDataYearResponse;
  };
  licenseStatus: { status?: string };
}
const initialState: AccountState = {
  license: { state: { value: LoadingState.NONE } },
  monthPaymentLicense: { state: { value: LoadingState.NONE } },
  yearPaymentLicense: { state: { value: LoadingState.NONE } },
  licenseStatus: { status: undefined },
};
const reducer = createReducer(
  initialState,

  on(accountActions.licenseLoad, (state) => ({
    ...state,
    license: { state: { value: LoadingState.LOADING } },
  })),
  on(accountActions.licenseDone, (state, props) => ({
    ...state,
    license: { state: props.state, data: props.data },
  })),
  on(accountActions.monthPaymentLoad, (state) => ({
    ...state,
    monthPaymentLicense: { state: { value: LoadingState.LOADING } },
  })),
  on(accountActions.monthPaymentDone, (state, props) => ({
    ...state,
    monthPaymentLicense: { state: props.state, data: props.data },
  })),
  on(accountActions.yearPaymentLoad, (state) => ({
    ...state,
    yearPaymentLicense: { state: { value: LoadingState.LOADING } },
  })),
  on(accountActions.yearPaymentDone, (state, props) => ({
    ...state,
    yearPaymentLicense: { state: props.state, data: props.data },
  })),
  on(accountActions.licenseStatus, (state, props) => ({
    ...state,
    licenseStatus: { status: props.status },
  })),
);
export function accountReducer(state: AccountState | undefined, action: Action) {
  return reducer(state, action);
}
